import { IMetadata } from '../../interfaces/common';
import { getApiCached } from '../../utils/api';

export interface IDoubleAppointmentReason extends IMetadata {
  doubleAppointmentReasonId: number;
  doubleAppointmentReasonDescription: string;
}

export const getDoubleAppointmentReasons = () =>
  getApiCached<IDoubleAppointmentReason[]>('lookup/doubleappointmentreasons');
